import ReactDOM from 'react-dom';

export const unmountUI2LibraryComponent = (
  container: Element | DocumentFragment,
): boolean => {
  return ReactDOM.unmountComponentAtNode(container);
};
